var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPtzControl = function SvgPtzControl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    className: "ptzControl_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M512 25.6C246.682 25.6 25.6 242.278 25.6 512a486.4 486.4 0 0 0 972.8 0C993.997 242.278 777.318 25.6 512 25.6m-4.403 897.638c-225.28 0-415.693-185.702-415.693-415.641C92.16 282.06 277.658 92.16 507.597 92.16c225.28 0 415.641 185.754 415.641 415.693a415.13 415.13 0 0 1-415.641 415.385"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m357.222 290.918 53.095 53.044L512 242.278l101.683 101.684 53.095-53.044L512 136.141zm-66.304 66.304L136.141 512l154.777 154.778 53.044-53.095L242.278 512l101.684-101.683zm216.679 424.5L405.862 680.038l-53.043 53.044 154.778 154.777 154.726-154.777-53.043-53.044zm221.081-424.5-52.838 53.095L777.318 512 675.84 613.683l53.094 53.095L883.456 512z"
  })));
};
export default SvgPtzControl;